export default function handleTwoFactorAuthorization(error, userEmail, userPhoneNumber) {
  const errors = error.response?.data.errors;

  return errors
    ? getTwoFactorAuthentication(errors, userEmail, userPhoneNumber)
    : { requiresAuth: false };
}


function getTwoFactorAuthentication(errors, userEmail, userPhoneNumber) {
  const twoFactorAuthentication = { requiresAuth: false };

  // eslint-disable-next-line no-restricted-syntax
  for (const error of errors) {
    const authType = getAuthType(error.code);

    if (authType) {
      const authPayload = {
        requiresAuth: true,
        contactInfo: authType.contactType === 'phoneNumber' ? userPhoneNumber : userEmail,
        ...authType
      };

      Object.assign(twoFactorAuthentication, authPayload);

      break;
    }
  }

  return twoFactorAuthentication;
}


function getAuthType(errorCode) {
  switch (errorCode) {
    case 'phone-already-exists-verification-required':
    case 'phone-number-verification-required':
      return {
        contactType: 'phoneNumber',
        authType: errorCode
      };

    case 'email-already-exists-verification-required':
    case 'email-verification-required':
      return {
        contactType: 'email',
        authType: errorCode
      };

    default:
      return null;
  }
}
